module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-vault-4.810ab926.svg";